
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { 
  getCommissionRequests, 
  getCommissionRequestById, 
  createCommissionRequest, 
  updateCommissionRequest 
} from "@/services/commission.service";
import { CommissionRequest } from "@/types/commission.types";

export const useCommissionRequests = (userId: string) => {
  return useQuery({
    queryKey: ['commission-requests', userId],
    queryFn: () => getCommissionRequests(userId),
    enabled: !!userId,
  });
};

export const useCommissionRequest = (id: string) => {
  return useQuery({
    queryKey: ['commission-request', id],
    queryFn: async () => {
      console.log("Hook: Fetching commission request with ID:", id);
      if (!id || id.trim() === '') {
        console.warn("Hook: No valid ID provided");
        throw new Error("ID da comissão é obrigatório");
      }
      
      const result = await getCommissionRequestById(id);
      console.log("Hook: Commission request result:", result);
      
      if (!result) {
        throw new Error("Comissão não encontrada");
      }
      
      return result;
    },
    enabled: !!id && id.trim() !== '',
    retry: 2,
    retryDelay: 1000,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};

export const useCreateCommissionRequest = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: createCommissionRequest,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['commission-requests'] });
      queryClient.invalidateQueries({ queryKey: ['commission-offers'] });
    },
  });
};

export const useUpdateCommissionRequest = () => {
  const queryClient = useQueryClient();
  
  return useMutation({
    mutationFn: ({ id, request }: { id: string; request: Partial<CommissionRequest> }) => 
      updateCommissionRequest(id, request),
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({ queryKey: ['commission-requests'] });
      queryClient.invalidateQueries({ queryKey: ['commission-request', variables.id] });
    },
  });
};
